<!-- BARRA NEGRA -------------------------------------------------------------->
<header class="top-bar" [class.mobile-sales]="isSalesMenu() && isMobile()">
  @if (isSalesMenu() && isMobile()) {
    <button class="mobile-hamburger" (click)="toggleMobileMenu()">
      <span></span>
      <span></span>
      <span></span>
    </button>
  }

  <div class="logo" (click)="goMainRoute()">
    <img src="/assets/logo-new.png" alt="Diseño y Gestión Inmobiliaria" />
  </div>

  @if (isSalesMenu() && isMobile()) {
    <div class="mobile-title">{{ activeSalesLabel() }}</div>
  }

  @if ((!isSalesMenu() || !isMobile()) && !isMenuLoading()) {
    <app-main-selector
      [options]="menu.mainOptions"
      [selected]="activeMain()"
      (selectionChange)="onMainChange($event)"
    ></app-main-selector>

    @if (initialized() && visibleSubOptions().length) {
      <app-sub-selector
        [options]="visibleSubOptions()"
        [selected]="activeSub()"
        (selectionChange)="onSubChange($event)"
      ></app-sub-selector>
    }
  }

  @if ((!isSalesMenu() || !isMobile()) && isMenuLoading()) {
    <!-- Loading indicator -->
    <div class="menu-loading">
      <span>Cargando menú...</span>
    </div>
  }

  @if ((!isSalesMenu() || !isMobile()) && menuError()) {
    <!-- Error indicator -->
    <div class="menu-error">
      <span>{{ menuError() }}</span>
    </div>
  }

  @if (
    (!isSalesMenu() || !isMobile()) &&
    (userProfile()?.realStateName || userProfile()?.realStateMultimedia?.url)
  ) {
    <div class="real-state">
      @if (userProfile()?.realStateMultimedia?.url) {
        <img
          class="real-state__logo"
          [src]="userProfile()?.realStateMultimedia?.url"
          [alt]="userProfile()?.realStateName || 'Inmobiliaria'"
          width="36"
          height="36"
        />
      }
      @if (userProfile()?.realStateName) {
        <span class="real-state__name">{{ userProfile()?.realStateName }}</span>
      }
    </div>
  }

  <div class="spacer" *ngIf="!isSalesMenu() || !isMobile()"></div>

  <app-top-actions
    *ngIf="!isSalesMenu() || !isMobile()"
    [actions]="actions()"
    [active]="activeAction()"
    (actionClick)="onAction($event)"
  ></app-top-actions>

  <!-- avatar + nombre (oculto en móvil ventas) -->
  <div class="user-box" *ngIf="!isSalesMenu() || !isMobile()" (click)="toggleUserMenu($event)">
    <img
      [src]="
        userProfile()?.multimedia?.url || '/assets/images/placeholder-avatar.png'
      "
      alt="avatar"
    />
    <div class="info">
      <strong>{{ userProfile()?.name || "-" }}</strong>
      <span>{{ topBarRoleName() }}</span>
    </div>
    <img class="arrow" ngSrc="/assets/down.svg" alt="" height="2" width="2" />

    <!-- dropdown -->
    @if (showUserMenu()) {
      <div class="user-menus" (click)="$event.stopPropagation()">
        <ul class="user-menu">
          <!-- <li (click)="onUserAction('profile')">Perfil</li>
          <li (click)="onUserAction('settings')">Configuración</li> -->
          <li (click)="onUserAction('switch-profile', $event)">
            Cambiar de perfil
          </li>
          <li (click)="onUserAction('logout', $event)" [class.logging-out]="isLoggingOut()">
            {{ isLoggingOut() ? "🔄 Cerrando sesión..." : "Cerrar sesión" }}
          </li>
        </ul>

        @if (showProfileSwitchMenu()) {
          <div class="profile-switch-menu">
            <header class="profile-switch-menu__header">Selecciona un perfil</header>

            @if (isLoadingProfiles()) {
              <p class="profile-switch-menu__empty">Cargando perfiles...</p>
            } @else if (!myProfiles().length) {
              <p class="profile-switch-menu__empty">No hay perfiles disponibles</p>
            } @else {
              <ul class="profile-switch-menu__list">
                @for (profile of myProfiles(); track profile.uuid) {
                  <li>
                    <button
                      type="button"
                      class="profile-switch-menu__option"
                      [class.active]="profile.active"
                      [disabled]="!profile.enable || !!switchingProfileUuid() || profile.active"
                      (click)="onProfileSwitch(profile, $event)"
                    >
                      <span class="profile-switch-menu__check" [class.active]="profile.active">✓</span>
                      <span class="profile-switch-menu__texts">
                        <strong>{{ profile.roleName || profile.name || 'Perfil sin nombre' }}</strong>
                        @if (profile.name && profile.name !== profile.roleName) {
                          <small>{{ profile.name }}</small>
                        }
                      </span>
                      @if (switchingProfileUuid() === profile.uuid) {
                        <span class="profile-switch-menu__status">Cambiando...</span>
                      } @else if (!profile.enable) {
                        <span class="profile-switch-menu__status">Inhabilitado</span>
                      }
                    </button>
                  </li>
                }
              </ul>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (showUserMenu() && (!isSalesMenu() || !isMobile())) {
    <div class="overlay" (click)="closeUserMenus()"></div>
  }
</header>

<!-- Mobile menu overlay for sales menu -->
@if (isSalesMenu() && isMobile() && mobileMenuOpen()) {
  <div class="mobile-menu-overlay" (click)="closeMobileMenu()"></div>
}

<!-- Mobile side menu for sales -->
@if (isSalesMenu() && isMobile()) {
  <div class="mobile-side-menu" [class.open]="mobileMenuOpen()">
    <div class="mobile-menu-header">
      <h3>Menú</h3>
      <button class="mobile-menu-close" (click)="closeMobileMenu()">✕</button>
    </div>
    <div class="mobile-menu-content">
      @for (item of mobileMenuItems(); track item.route) {
        <button
          class="mobile-menu-item"
          [class.active]="currentUrl().startsWith(item.route)"
          (click)="onMobileMenuItemClick(item)"
        >
          @if (item.icon && item.icon.url) {
            <img class="menu-item-icon" [src]="item.icon.url" [alt]="item.name"/>
          }
          <span class="menu-item-name">{{ item.name }}</span>
          @if (currentUrl().startsWith(item.route)) {
            <span class="menu-item-check">✓</span>
          }
        </button>
      }
    </div>
  </div>
}

@if ((!isSalesMenu() || !isMobile()) && sections().length && !isNotificationsRoute()) {
  <nav class="sub-nav">
    <div class="sub-nav-sections">
      @for (sec of sections(); track sec.route) {
        <button
          [class.active]="isSectionActive(sec)"
          [class.has-sub]="shouldShowSectionDropdown(sec)"
          (click)="onSectionClick(sec, $event)"
        >
          <span class="btn-label">{{ sec.name }}</span>
          @if (shouldShowSectionDropdown(sec)) {
            <svg
              class="caret"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="currentColor"
                d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
              />
            </svg>

            @if (openedSectionRoute() === sec.route) {
              <ul class="dropdown">
                @for (ss of getVisibleSubSections(sec); track ss.route) {
                  <li (click)="onSubSectionClick(sec, ss, $event)">
                    {{ ss.name }}
                  </li>
                }
              </ul>
            }
          }
        </button>
      }
    </div>
    @if (showRankingAction()) {
      <button class="sub-nav-action" type="button" (click)="goToRanking()">
        Top ranking
      </button>
    }
  </nav>
}

<!-- CONTENIDO --------------------------------------------------------------->
<main class="content" [class.with-bottom-nav]="isSalesMenu() && isMobile()">
  <router-outlet></router-outlet>
</main>

@if (isSalesMenu() && isMobile()) {
  <nav class="sales-bottom-nav">
    @for (item of mobileMenuItems(); track item.route) {
      <a class="nav-item"
         [routerLink]="item.route"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: false }">
        @if (item.icon && item.icon.url) {
          <img class="icon" [src]="item.icon.url" [alt]="item.name"/>
        }
        <span class="label">{{ item.name }}</span>
      </a>
    }
  </nav>
}
